export default {
  methods: {
    decodeUsage (address, prefix = true) {
      let usage = address.customer_usage,
        decodedUsage = address.decoded_customer_usage,
        ret = prefix ? "Adresse " : "",
        pronoun = "de"

      if (usage === "corresponding")
          decodedUsage += " (factures)"

      if (usage !== "main")
        ret += pronoun + " "
      ret += _.toLower(decodedUsage)

      return ret
    }
  },
}



// WEBPACK FOOTER //
// ./client/mixins/address.js